import React from 'react'
import PervPlay from './Play'
import Login from "./Login";
import AddMenu from "./AddMenu";
import QuizMenu from "./QuizMenu"
import Home from "./Home";
import EditAccount from './EditAccount';
import Signup from './Signup';
import { BrowserRouter as Router, Route, Routes, useLocation, Navigate} from 'react-router-dom';
import {AnimatePresence, motion} from "framer-motion";
import TopBar from './TopBar';
import {getAuth, signOut} from 'firebase/auth';
import ProtectedRoutes from './ProtectedRoutes';
import ProtectedRoutesLoggedIn from './ProtectedRoutesLoggedIn';

//this component exists bc you cant use the useLocation() hook unless its called in a component inside of <router>
//https://www.youtube.com/watch?v=FdrEjwymzdY


function AnimatedRoutes() {
     const location = useLocation();
    const auth = getAuth();
    const user = auth.currentUser;
     return (
          <div className='mainAppContainer'>
            
          <AnimatePresence exitBeforeEnter initial={false}>
            
            <Routes location={location} key={location.pathname} >
              
              {/* //dont show these when logged in */}
              <Route element={<ProtectedRoutesLoggedIn />} >                  
                <Route path="/app/" element={<Login />} />
                <Route path="/app/signup" element={<Signup />} />
              </Route>

              {/* //ONLY show these when logged in */}
              <Route element={<ProtectedRoutes />} >
                <Route path="/app/home" element={<Home />} />
                <Route path="/app/editAccount" element={<EditAccount />} />
                <Route path="/app/addMenu" element={<AddMenu />} />
                <Route path="/app/quizMenu" element={<QuizMenu />} />
              </Route>
              

            </Routes>
          </AnimatePresence>  
          </div>
     )
}

export default AnimatedRoutes
